export function normalizeStoryNotificationLink(link: string, notificationType?: string): string {
  if (notificationType !== '13' || !link) return link;

  const [linkWithoutHash, hash = ''] = link.split('#', 2);
  const queryIndex = linkWithoutHash.indexOf('?');
  const path = queryIndex === -1 ? linkWithoutHash : linkWithoutHash.slice(0, queryIndex);
  const query = queryIndex === -1 ? '' : linkWithoutHash.slice(queryIndex + 1);

  if (!/(?:^|\/)@[^/?]+$/i.test(path) || !/(?:^|&)story=\d+(?:&|$)/i.test(query)) {
    return link;
  }

  if (/(?:^|&)comments=(?:1|true)(?:&|$)/i.test(query)) {
    return link;
  }

  const separator = query ? '&' : '';
  return `${linkWithoutHash}${separator}comments=1${hash ? `#${hash}` : ''}`;
}
